<ng-container>
	<div class="header-padding">
		<div class="header-container">
			<div class="report-info">
				<h2 class="report-title">{{executiveTitle}}</h2>
				<p class="report-subtitle">
					a snapshot of operational performance, costs, and productivity across your mine sites
				</p>
			</div>
			<div class="icon-tab-group">
				<div class="icon-tab" [class.active]="selectedTab === 0" (click)="selectTab(0)">
					<mat-icon class="tab-select-icon" svgIcon="overview-icon" matTooltip="Executive"></mat-icon>
				</div>
				<div class="icon-tab" [class.active]="selectedTab === 1" (click)="selectTab(1)">
					<mat-icon class="tab-select-icon" svgIcon="keymetrics-icon" matTooltip="Key Metrics"></mat-icon>
				</div>
				<div class="icon-tab" [class.active]="selectedTab === 2" (click)="selectTab(2)">
					<mat-icon class="tab-select-icon" svgIcon="costs-icon" matTooltip="costs"></mat-icon>
				</div>
			</div>
		</div>
	</div>
	<div class="chart-wrapper">
		<div class="overview-dashboard-wrapper">
			<div class="content-container empty-image"
				*ngIf="!this.drillData || !this.fragmentationData || !this.fieldersData || !this.totalCostsData || !this.operationalCostsData">
				<div class="domain-loading-container">
					<mat-spinner class="no-data"></mat-spinner>
					<span>Loading your data. Please wait...</span>

					<div class="loading-logo-overlay">
						<app-logo></app-logo>

						<div class="animate"></div>
					</div>
				</div>
			</div>

			<div *ngIf="selectedTab === 0">
				<app-executive-chart-section collapseStateKey="overview" [chartOptionsList]="overviewChartOptions" [Highcharts]="Highcharts" [collapsible]="true"
					(chartInstance)="onChartInstance($event.event, $event.index)">
				</app-executive-chart-section>
			</div>

			<div *ngIf="selectedTab === 1">
				<app-executive-chart-section collapseStateKey="key-metrics" [chartOptionsList]="keyMetricsCharts" [Highcharts]="Highcharts" [collapsible]="true"
					(chartInstance)="onChartInstance($event.event, $event.index)">
				</app-executive-chart-section>
			</div>

			<div *ngIf="selectedTab === 2">
				<app-executive-chart-section collapseStateKey="costs" [chartOptionsList]="costsChartOptions" [Highcharts]="Highcharts" [collapsible]="true"
					(chartInstance)="onChartInstance($event.event, $event.index)">
				</app-executive-chart-section>
			</div>
		</div>
	</div>
</ng-container>